<div class="tl-wrap">

  <!-- KPI strip -->
  <div class="tl-kpis" *ngIf="mkpi && mkpi.available">
    <div class="tl-card tl-kpi">
      <span class="tl-label">Item Daftar</span>
      <span class="tl-num">{{formatNumber(mkpi.items_total)}}</span>
      <span class="tl-kpi-foot">{{formatNumber(mkpi.items_juz)}} juz &middot; {{formatNumber(mkpi.items_surah)}} surat &middot; {{formatNumber(mkpi.items_pages)}} halaman &middot; {{formatNumber(mkpi.list_users)}} pengguna</span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Sesi 7 Hari</span>
      <span class="tl-num">{{formatNumber(mkpi.sessions_7d)}}</span>
      <span class="tl-kpi-foot">{{formatNumber(mkpi.pages_7d)}} halaman diulang oleh {{formatNumber(mkpi.users_7d)}} pengguna</span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Kelancaran 30 Hari</span>
      <span class="tl-num">{{murojaahLancarPct()}}<span class="tl-num-of">%</span></span>
      <span class="tl-kpi-foot">
        <span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="murojaahLancarPct()"></span></span>
        {{formatNumber(mkpi.lancar_30d)}} lancar &middot; {{formatNumber(mkpi.tersangkut_30d)}} tersangkut &middot; {{formatNumber(mkpi.lupa_30d)}} lupa
      </span>
    </div>
    <div class="tl-card tl-kpi">
      <span class="tl-label">Halaman Lemah</span>
      <span class="tl-num" [class.tl-warn]="mkpi.weak_pages">{{formatNumber(mkpi.weak_pages)}}</span>
      <span class="tl-kpi-foot">terakhir dinilai tersangkut/lupa &middot; {{formatNumber(mkpi.weak_users)}} pengguna</span>
    </div>
  </div>
  <div class="tl-kpis" *ngIf="mkpi && !mkpi.available">
    <div class="tl-card tl-kpi">
      <span class="tl-label">Muraja'ah</span>
      <span class="tl-num tl-num-sm">Belum tersedia</span>
      <span class="tl-kpi-foot">tabel muraja'ah belum ada di database ini &mdash; jalankan migrasi API terbaru</span>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="vl-toolbar">
        <div class="tl-seg" role="tablist" aria-label="Tampilan">
          <button type="button" role="tab" [class.on]="mView == 'users'" (click)="setView('users')">Pengguna</button>
          <button type="button" role="tab" [class.on]="mView == 'sessions'" (click)="setView('sessions')">Sesi</button>
        </div>
        <input class="vl-input" type="search" placeholder="Cari nama pengguna&hellip;"
               aria-label="Cari muraja'ah" [value]="mKeyword"
               (input)="onMurojaahKeywordInput($event.target.value)" (keyup.enter)="applyMurojaahFilter()">
        <select class="vl-select" aria-label="Urutkan" *ngIf="mView == 'users'" [value]="mSort" (change)="mSort = $event.target.value; applyMurojaahFilter()">
          <option value="activity">Sesi terakhir</option>
          <option value="items">Item terbanyak</option>
          <option value="pages">Halaman terbanyak</option>
          <option value="sessions">Sesi terbanyak</option>
          <option value="weak">Halaman lemah terbanyak</option>
        </select>
        <select class="vl-select" aria-label="Rentang waktu" *ngIf="mView == 'sessions'" [value]="mDays" (change)="mDays = $event.target.value; applyMurojaahFilter()">
          <option value="7">7 hari terakhir</option>
          <option value="30">30 hari terakhir</option>
          <option value="90">90 hari terakhir</option>
          <option value="">Semua waktu</option>
        </select>
        <div class="vl-spacer"></div>
        <span class="tl-readonly" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
      </div>

      <!-- ===== PENGGUNA ===== -->
      <div class="vl-card" *ngIf="mView == 'users'">
        <div class="vl-loading" *ngIf="mUsersLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
        <div class="vl-scroll">
        <table class="vl-table">
          <thead>
          <tr>
            <th class="vl-num">No</th>
            <th>Pengguna</th>
            <th>Item Daftar</th>
            <th class="text-center">Halaman Diulang</th>
            <th class="text-center">Sesi</th>
            <th style="width: 18%">Kelancaran 30 Hari</th>
            <th class="text-center">Halaman Lemah</th>
            <th>Sesi Terakhir</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let u of mUsers; let i = index" class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1" (click)="openUser(u.id, u.name, u.email, u.photoUrl)">
            <th class="vl-num">{{rangeFrom(mUsersPage, mUsersTotal) + i}}</th>
            <td>
              <div class="tl-ident">
                <img [src]="u.photoUrl || 'assets/images/no_avatar.webp'" alt="" class="tl-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                <div class="tl-ident-text">
                  <span class="vl-name" [innerHTML]="highlight(u.nameVw, mKeyword)"></span>
                  <span class="tl-desc" *ngIf="u.email" [innerHTML]="highlight(u.email, mKeyword)"></span>
                </div>
              </div>
            </td>
            <td>
              <ng-container *ngIf="u.items_total">
                <span class="tl-count">{{formatNumber(u.items_total)}} item</span>
                <div class="vl-muted vl-small">{{u.lastItemVw}}</div>
              </ng-container>
              <span class="vl-muted" *ngIf="!u.items_total">Belum ada daftar</span>
            </td>
            <td class="text-center"><span class="tl-count">{{formatNumber(u.pages_reviewed)}}</span></td>
            <td class="text-center">{{formatNumber(u.sessions_total)}}<div class="vl-muted vl-small" *ngIf="u.sessions_7d">{{formatNumber(u.sessions_7d)}} pekan ini</div></td>
            <td>
              <ng-container *ngIf="u.lancar_pct_30d != null">
                <div class="tl-today"><span class="tl-bar wide"><span class="tl-bar-fill" [style.width.%]="u.lancar_pct_30d"></span></span><span class="tl-pct">{{u.lancar_pct_30d}}%</span></div>
                <div class="vl-muted vl-small">{{u.lancar_30d}} lancar &middot; {{u.tersangkut_30d}} tersangkut &middot; {{u.lupa_30d}} lupa</div>
              </ng-container>
              <span class="vl-muted" *ngIf="u.lancar_pct_30d == null">&mdash;</span>
            </td>
            <td class="text-center"><span [class.tl-warn]="u.weak_pages">{{formatNumber(u.weak_pages)}}</span></td>
            <td><span [title]="u.lastSessionFull">{{u.lastSessionVw}}</span></td>
          </tr>
          <tr *ngIf="!mUsers.length && !mUsersLoading"><td colspan="8" class="vl-empty">Belum ada pengguna yang muraja'ah</td></tr>
          </tbody>
        </table>
        </div>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(mUsersPage, mUsersTotal))}}&ndash;{{formatNumber(rangeTo(mUsersPage, mUsers.length))}}</b> dari <b>{{formatNumber(mUsersTotal)}}</b> pengguna</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi pengguna muraja'ah">
            <button type="button" class="vl-page" [disabled]="mUsersPage == 1" (click)="goMurojaahUsersPage(mUsersPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of mUsersPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == mUsersPage" (click)="goMurojaahUsersPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="mUsersPage == pagesOf(mUsersTotal)" (click)="goMurojaahUsersPage(mUsersPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

      <!-- ===== SESI ===== -->
      <div class="vl-card" *ngIf="mView == 'sessions'">
        <div class="vl-loading" *ngIf="mSessionsLoading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
        <ul class="tl-feed">
          <li *ngFor="let s of mSessions" class="tl-feed-row tl-rowlink" (click)="openUser(s.user_id, s.user_name, s.user_email, s.userPhotoUrl)">
            <img [src]="s.userPhotoUrl || 'assets/images/no_avatar.webp'" alt="" class="tl-avatar-md" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
            <div class="tl-feed-body">
              <div class="tl-feed-text"><b [innerHTML]="highlight(s.userName, mKeyword)"></b> muraja'ah <b>{{s.pages_text}}</b><ng-container *ngIf="s.juzVw"> &middot; {{s.juzVw}}</ng-container></div>
              <div class="tl-feed-meta">
                <span class="vl-tag kind">{{formatNumber(s.page_count)}} halaman</span>
                <span class="vl-tag grade-lancar" *ngIf="s.lancar_count">{{s.lancar_count}} lancar</span>
                <span class="vl-tag grade-tersangkut" *ngIf="s.tersangkut_count">{{s.tersangkut_count}} tersangkut</span>
                <span class="vl-tag grade-lupa" *ngIf="s.lupa_count">{{s.lupa_count}} lupa</span>
                <span>{{s.dayVw}}<ng-container *ngIf="s.durationVw"> &middot; {{s.durationVw}}</ng-container></span>
              </div>
            </div>
            <time class="tl-feed-time" [title]="s.timeFull">{{s.timeVw}}</time>
          </li>
          <li *ngIf="!mSessions.length && !mSessionsLoading" class="vl-empty">Tidak ada sesi muraja'ah pada rentang ini</li>
        </ul>
        <div class="vl-foot">
          <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(mSessionsPage, mSessionsTotal))}}&ndash;{{formatNumber(rangeTo(mSessionsPage, mSessions.length))}}</b> dari <b>{{formatNumber(mSessionsTotal)}}</b> sesi</span>
          <div class="vl-spacer"></div>
          <nav class="vl-pager" aria-label="Navigasi sesi muraja'ah">
            <button type="button" class="vl-page" [disabled]="mSessionsPage == 1" (click)="goMurojaahSessionsPage(mSessionsPage - 1)">&lsaquo;</button>
            <ng-container *ngFor="let p of mSessionsPages">
              <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
              <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == mSessionsPage" (click)="goMurojaahSessionsPage(p)">{{p}}</button>
            </ng-container>
            <button type="button" class="vl-page" [disabled]="mSessionsPage == pagesOf(mSessionsTotal)" (click)="goMurojaahSessionsPage(mSessionsPage + 1)">&rsaquo;</button>
          </nav>
        </div>
      </div>

    </div>
  </div>
</div>
